import { PUBLIC_PATHS } from "../data/publicRoutes";
import { VEHICLES } from "../data/vehicles";
import { POPULAR_ROUTES } from "../data/routes";

export const GA4_ID = "G-BGMQQNGXFD";
const events = new Set(["page_view", "call_click", "whatsapp_click", "generate_lead", "quote_request", "fare_calc_used", "begin_checkout", "booking_form_submit", "quote_form_submit", "quote_button_click", "contact_form_submit", "vehicle_page_view", "view_item", "route_page_view", "select_content"]);
const sources = new Set(["home", "header", "header-mobile", "footer", "hero", "generic", "contact-section", "instant-quote", "floating", "fare-calc", "fare-calculator", "google", "fallback", "local", "route", "vehicle", ...VEHICLES.flatMap((v) => [v.slug, `vehicle-${v.slug}`]), ...POPULAR_ROUTES.flatMap((r) => [r.slug, `route-${r.slug}`])]);
const vehicleIds = new Set(VEHICLES.map((v) => v.slug));
const vehicleNames = new Set(VEHICLES.map((v) => v.name));
const routeIds = new Set(POPULAR_ROUTES.map((r) => r.slug));

export function analyticsContext(pathname) {
    const prefix = globalThis.__VVPSS_BASE_PATH__ || "";
    const path = pathname || window.location.pathname.slice(prefix.length) || "/";
    if (!PUBLIC_PATHS.includes(path)) return null;
    const qa = Boolean(globalThis.__VVPSS_PREVIEW__) || window.location.origin !== process.env.REACT_APP_SITE_URL;
    return {
        page_location: `${window.location.origin}${prefix}${path}`,
        page_referrer: "",
        page_title: path === "/" ? "VVPSS Pvt. Ltd. Taxi Services" : `VVPSS | ${path.slice(1).replace(/-/g, " ")}`,
        app_environment: qa ? "qa_preview" : "production",
        ...(qa ? { debug_mode: true, traffic_type: "developer", qa_test: true } : {}),
    };
}

export function sanitizeAnalyticsParams(input = {}) {
    const safe = {};
    for (const [key, value] of Object.entries(input)) {
        if (key === "source") safe.source = sources.has(value) ? value : "other";
        else if (["vehicle", "item_id"].includes(key) && vehicleIds.has(value)) safe[key] = value;
        else if (key === "item_name" && vehicleNames.has(value)) safe[key] = value;
        else if (key === "route" && routeIds.has(value)) safe.route = value;
        else if (key === "currency" && value === "INR") safe.currency = value;
        else if (key === "value" && typeof value === "number" && Number.isFinite(value) && value >= 0) safe.value = value;
        else if (key === "method" && ["whatsapp", "phone", "quote_form", "booking_form"].includes(value)) safe.method = value;
        else if (key === "event_category" && value === "conversion") safe.event_category = value;
        else if (key === "content_type" && value === "route") safe.content_type = value;
    }
    return safe;
}

export function sendAnalyticsEvent(event, input = {}, pathname) {
    if (typeof window === "undefined" || !events.has(event)) return;
    const context = analyticsContext(pathname);
    if (!context || typeof window.gtag !== "function") return;
    // One channel: gtag itself queues in dataLayer. Never push the event a second time.
    window.gtag("set", context);
    window.gtag("event", event, { ...sanitizeAnalyticsParams(input), ...context, send_to: GA4_ID });
}